// src/features/payments/api.js
import api from "../../components/axiosComp";

// List (supports filters & pagination)
export const listPayments = async (params = {}) => {
  const { data } = await api.get("/api/payments", { params });
  return data; // { page, limit, total, pages, items: [...] }
};

// Details
export const getPaymentById = async (id) => {
  const { data } = await api.get(`/api/payments/${id}`);
  return data;
};

// Manual add (optional)
export const createPayment = async (payload) => {
  const { data } = await api.post("/api/payments", payload);
  return data; // { message, id }
};

// Export (CSV/XLSX/PDF) -> triggers download
export const exportPayments = async (params = {}) => {
  const { format = "csv" } = params;
  const { data } = await api.get("/api/payments/export", {
    params,
    responseType: "blob",
  });
  const fname = `payments.${format}`;
  const url = window.URL.createObjectURL(new Blob([data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = fname;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

// KPI totals
export const getPaymentsSummary = async (params = {}) => {
  const { data } = await api.get("/api/payments/summary", { params });
  return data; // {count, totalAmount, commission, gatewayFee, netCommission, venueSettlement}
};

// Grouped by month
export const getPaymentsSummaryByMonth = async (params = {}) => {
  const { data } = await api.get("/api/payments/summary/by-month", { params });
  return data; // { items: [ { month, count, totalAmount, ... } ] }
};

// Grouped by venue
export const getPaymentsSummaryByVenue = async (params = {}) => {
  const { data } = await api.get("/api/payments/summary/by-venue", { params });
  return data; // { items: [ { venueId, venueName, count, totalAmount, ... } ] }
};
